"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingLogEntryStruct = void 0;
const superstruct_1 = require("superstruct");
const Timestamp_1 = require("../utils/Timestamp");
const messaging_1 = require("./messaging");
const price_1 = require("./price");
exports.BillingLogEntryStruct = (0, superstruct_1.type)({
    refId: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    userId: (0, superstruct_1.string)(),
    organisationId: (0, superstruct_1.string)(),
    createdAt: Timestamp_1.TimestampStruct,
    messageType: messaging_1.BillableMessageTypeEnums,
    provider: messaging_1.MessageProviderEnums,
    countryCode: (0, superstruct_1.string)(),
    price: price_1.PriceStruct,
});
//# sourceMappingURL=billingLog.js.map